import { FC } from 'react';
import { MediaManager } from 'src/manager/MediaManager';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    imageSrc: string;
    link: string;
    styles: Styles;
  };
};
const Ebac: FC<Props> = ({ settings }) => {
  const { styles, imageSrc, link } = settings;

  return (
    <div className="ebac_wrapper">
      <a href={link} target="_blank" rel="noopener noreferrer" aria-label="Learn more about EBAC">
        <img src={MediaManager.getSrcFromLocaleFolder(imageSrc, '/')} alt="EBAC" className="ebac" style={styles} />
      </a>
    </div>
  );
};
export default Ebac;
